import React, { Component } from 'react';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText} from '../../theme/MorsTheme';
import {Row,Col} from 'react-bootstrap';
import {PDF_REPORTS_URL} from '../../resources/constant';
import {viewFlatFile} from '../../Utilities/WSUtil';


export default class morsFAQS extends Component {

  constructor(props){
    super(props);

    this.state = {
      pdfFile:''
    }
 }

  componentWillMount(){
    //this.showFAQS()
    this.downloadPDF()
  }

  /*base64ToArrayBuffer(data) {
    var binaryString = window.atob(data);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
  }
*/
  showFAQS(){
    var fileName = "FAQS.pdf"
    var path = PDF_REPORTS_URL+fileName;
    var basepath = "otp_path_gen";

    viewFlatFile(basepath, path, {
      responseType: "blob"
    })
    .then(response => {
        
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //IE11 and the legacy version Edge support
        console.log("IE & Edge");
        let blob = new Blob([response.data], { type: "application/pdf" });
        //window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {// other browsers
          console.log("response data = " + response);

          //var arrBuffer = this.base64ToArrayBuffer(response);

          //const file = new Blob([response.data], { type: "application/pdf" });
          //console.log("file = " + file);  
          
          var len = response.length;
          var bytes = new Uint8Array(len);
          for(var i=0; i<len; i++){
            bytes[1] = response.charCodeAt(i)

          }

          const file =  new Blob([bytes.buffer], { type: "application/pdf" })
          console.log("file = " + file);

          this.setState({
            pdfFile:file 
          }) 

          console.log("pdfFile = " + this.state.pdfFile);
      }
    })
  }

  downloadPDF() {

    var fileName = "FAQS.pdf"
    var path = PDF_REPORTS_URL+fileName;
    var basepath = "otp_path_gen";

    
    fetch(viewFlatFile(basepath, path))
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '<PDF-blob-name>';
        link.click();

        this.setState({
          pdfFile:blob 
        }) 

        console.log("pdfFile = " + this.state.pdfFile);

      })
      .catch(error => console.error(error));
  }

  render() {
    //var url = PDF_REPORTS_URL+'MORS_QRG.pdf';
    var file = PDF_REPORTS_URL+'FAQS.pdf';

    return (
    <div>
      <BodyHeaderDiv>
          <BodyHeaderText>Quick Reference Guide</BodyHeaderText>
      </BodyHeaderDiv>
      <ContentDiv>
      <Row>
                <Col>
                <object width="100%" height="650px" data={this.state.pdfFile} type="application/pdf"></object>
                </Col>
        </Row>
      </ContentDiv>
    </div>
    );
  }
}